module.exports = __webpack_public_path__ + "static/media/image1.e09de22d.jpg";